import { ref } from 'vue';

export const toastVisible = ref(false);
export const toastMessage = ref('');
export const toastType = ref<'success' | 'info' | 'error'>('success');

export function showToast(message: string, type: 'success' | 'info' | 'error' = 'success') {
  toastMessage.value = message;
  toastType.value = type;
  toastVisible.value = true;

  setTimeout(() => {
    toastVisible.value = false;
  }, 2000);
}

